exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".qrcode-display[data-v-6a57b048]{text-align:center;padding:10px}.qrcode-container[data-v-6a57b048]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;margin-bottom:20px}.qrcode-canvas[data-v-6a57b048]{width:200px;height:200px;border:1px solid #e4e7ed;border-radius:8px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);object-fit:contain;background-color:#fff}.status-area[data-v-6a57b048]{margin:15px 0;min-height:40px}.status-text[data-v-6a57b048]{font-size:14px;margin:0}.status-text.pending[data-v-6a57b048]{color:#e6a23c}.status-text.success[data-v-6a57b048]{color:#67c23a}.status-text.failed[data-v-6a57b048]{color:#f56c6c}.actions[data-v-6a57b048]{margin-top:10px;display:-ms-flexbox;display:flex;gap:10px;-ms-flex-pack:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a57b048","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/payment.vue
// module id = 229
// module chunks = 0